module.exports = __webpack_public_path__ + "img/ankkuripaikka.5864c762.jpg";